import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static savedScrollY = 0

  connect() {
    this.boundEscapeHandler = this.closeOnEscape.bind(this)
    this.boundPopstateHandler = this.handlePopstate.bind(this)
    this.boundFrameLoadHandler = this.handleFrameLoad.bind(this)

    document.addEventListener('keydown', this.boundEscapeHandler)
    window.addEventListener('popstate', this.boundPopstateHandler)
    document.addEventListener('turbo:frame-load', this.boundFrameLoadHandler)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundEscapeHandler)
    window.removeEventListener('popstate', this.boundPopstateHandler)
    document.removeEventListener('turbo:frame-load', this.boundFrameLoadHandler)
  }

  // ── Scroll lock ──────────────────────────────────────────────────────────────

  lockBodyScroll() {
    if (document.body.dataset.scrollLocked === 'true') return
    this.constructor.savedScrollY = window.scrollY
    document.body.dataset.scrollLocked = 'true'
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${this.constructor.savedScrollY}px`
    document.body.style.width = '100%'
  }

  unlockBodyScroll() {
    if (document.body.dataset.scrollLocked !== 'true') return
    const scrollY = this.constructor.savedScrollY
    document.body.dataset.scrollLocked = 'false'
    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY)
    })
  }

  anyModalOpen() {
    return Array.from(document.querySelectorAll('[data-controller~="modal"]'))
      .some(el => el.innerHTML.trim() !== '')
  }

  updateScrollLock() {
    if (this.anyModalOpen()) {
      this.lockBodyScroll()
    } else {
      this.unlockBodyScroll()
    }
  }

  // ── Frame load ───────────────────────────────────────────────────────────────

  handleFrameLoad(event) {
    if (event.target === this.element) {
      this.updateScrollLock()
    }
  }

  frameLoaded() {
    this.updateScrollLock()
  }

  // ── Close actions ────────────────────────────────────────────────────────────

  close(event) {
    event?.preventDefault()
    event?.stopPropagation()
    this.closeFrame()
  }

  closeOnBackdrop(event) {
    if (event.target.classList.contains('modal-overlay')) {
      this.close(event)
      return
    }
    const closeBtn = event.target.closest('.modal-close-btn')
    if (closeBtn) this.close(event)
  }

  closeOnEscape(event) {
    if (event.key !== 'Escape') return
    // Only close the topmost (last non-empty) modal frame
    const openModals = Array.from(document.querySelectorAll('[data-controller~="modal"]'))
      .filter(el => el.innerHTML.trim() !== '')
    if (openModals[openModals.length - 1] === this.element) {
      this.close()
    }
  }

  handlePopstate() {
    this.closeFrame()
  }

  closeFrame() {
    if (this.element.innerHTML.trim() !== '') {
      this.element.innerHTML = ''
      this.updateScrollLock()
    }
  }
}
